import { render, staticRenderFns } from "./ToolBox.vue?vue&type=template&id=20227162&scoped=true"
import script from "./ToolBox.vue?vue&type=script&lang=js"
export * from "./ToolBox.vue?vue&type=script&lang=js"
import style0 from "./ToolBox.vue?vue&type=style&index=0&id=20227162&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20227162",
  null
  
)

export default component.exports